module.exports = __webpack_public_path__ + "img/agenda.75422b46.svg";